import { ROUTES_CREWS_LIST } from '@/constants/routes';

export default {
    name: ROUTES_CREWS_LIST,
    component: () => import(/*webpackChunkName: 'crews-page'*/ '@/views/crews/Crews.vue'),
    path: '/crews'
};
